import { render, staticRenderFns } from "./MyGroupTaskList.vue?vue&type=template&id=39d553ab&scoped=true&"
import script from "./MyGroupTaskList.vue?vue&type=script&lang=js&"
export * from "./MyGroupTaskList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d553ab",
  null
  
)

export default component.exports